import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useMemo, useCallback } from 'react';
import { Icon as SemanticIcon, } from 'semantic-ui-react';
import _ from 'lodash';
import { colorVars, colorShortToLong, INHERIT } from '../../../utils/colors';
const ICON_STYLES = ['solid', 'regular', 'light', 'brand'];
const PREFIXES = ['fas', 'far', 'fal', 'fab'];
const Icon = ({ className, color: colorName = 'gray', hoverColor: hoverColorName = '', iconStyle = '', name, size, style, onMouseOver, onMouseOut, ...rest }) => {
    const [hover, setHover] = useState(false);
    const handleMouseOut = useCallback(() => {
        if (!hover)
            return;
        setHover(false);
        onMouseOut?.();
    }, [hover, onMouseOut]);
    const handleMouseOver = useCallback(() => {
        if (hover)
            return;
        setHover(true);
        onMouseOver?.();
    }, [hover, onMouseOver]);
    let prefix = '';
    const colorKey = useMemo(() => colorShortToLong(colorName || ''), [colorName]);
    const baseColor = colorName === INHERIT
        ? INHERIT
        : colorVars[colorKey];
    let hoverColor;
    const hoverColorKey = useMemo(() => colorShortToLong(hoverColorName || ''), [hoverColorName]);
    if (hoverColorName === INHERIT) {
        hoverColor = INHERIT;
    }
    else if (hoverColorName) {
        hoverColor = colorVars[hoverColorKey];
    }
    else {
        hoverColor = baseColor;
    }
    const color = hover ? hoverColor : baseColor;
    let newSize = size;
    let sizeOverrideStyle = {};
    if (newSize === 'medium') {
        newSize = undefined;
        sizeOverrideStyle = { fontSize: '16px' };
    }
    let newName = name;
    if (iconStyle) {
        const index = _.indexOf(ICON_STYLES, iconStyle);
        if (index >= 0 && index < ICON_STYLES.length) {
            prefix = PREFIXES[index];
        }
        newName = `${name.slice(0, 3) === 'fa-' ? '' : 'fa-'}${name}`;
    }
    return (_jsx(SemanticIcon, { className: `${className || ''} ${prefix} ${newName}`, name: '', onMouseOut: handleMouseOut, onMouseOver: handleMouseOver, size: newSize, style: {
            color,
            ...sizeOverrideStyle,
            ...style,
            opacity: 1,
        }, ...rest }));
};
const IconWithStatic = Icon;
IconWithStatic.defaultProps = {
    color: 'gray',
    hoverColor: '',
    iconStyle: '',
};
IconWithStatic.Group = SemanticIcon.Group;
export default Icon;
//# sourceMappingURL=index.js.map